import React, { useEffect, useState } from "react";

import { Instant } from "@js-joda/core";
import { formatDuration, timeDifference } from "../../../utils/time-utils";

const TimeDiff = ({ time }: { time: Instant }) => {
  const [diffSec, setDiffSec] = useState(timeDifference(time));

  useEffect(() => {
    const interval = setInterval(() => {
      setDiffSec(difSec => difSec + 1);
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    setDiffSec(timeDifference(time));
  }, [time]);

  return <>{formatDuration(diffSec)}</>;
};

export default TimeDiff;
